import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import BarChart from '@material-ui/icons/BarChart';
import SchoolIcon from '@material-ui/icons/School';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ApartmentIcon from '@material-ui/icons/Apartment';
import LocalFloristIcon from '@material-ui/icons/LocalFlorist';
import PolicyIcon from '@material-ui/icons/Policy';
import RevenueExpenditure from './RevenueExpenditure';
import EducationBudget from './EducationBudget';
import HealthBudget from './HealthBudget';
import HigherEducationBudget from './HigherEducationBudget';
import AgricultureBudget from './AgricultureBudget';
import RecentCustomRevenue from '../CustomRevenueCollection/RecentCustomRevenueList';
import { tokens } from '../../theme';

function TabPanel({ children, value, index }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`budget-tabpanel-${index}`}
            aria-labelledby={`budget-tab-${index}`}
        >
            {value === index && children}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const a11yProps = (index) => ({
    id: `budget-tab-${index}`,
    'aria-controls': `budget-tabpanel-${index}`,
});

const StyledTabs = withStyles({
    root: {
        borderBottom: `1px solid ${tokens.border}`,
        minHeight: 0,
    },
    indicator: {
        height: 3,
        backgroundColor: tokens.blue600,
    },
})(Tabs);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 96,
        padding: theme.spacing(1.5, 2.5),
        color: tokens.muted,
        '&$selected': { color: tokens.blue700 },
        '&:hover': { color: tokens.blue700 },
    },
    wrapper: {
        flexDirection: 'row',
        gap: 8,
        '& > *:first-child': {
            marginBottom: '0 !important',
            fontSize: 20,
        },
    },
    selected: {},
}))((props) => <Tab {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        border: `1px solid ${tokens.border}`,
        borderRadius: tokens.radius,
        overflow: 'hidden',
        backgroundColor: tokens.white,
    },
    panel: {
        padding: theme.spacing(4),
        [theme.breakpoints.down('sm')]: { padding: theme.spacing(2) },
    },
}));

const panels = [
    { label: 'Expenditure', icon: <BarChart />, render: () => <RevenueExpenditure /> },
    { label: 'Education', icon: <SchoolIcon />, render: () => <EducationBudget /> },
    { label: 'Health', icon: <LocalHospitalIcon />, render: () => <HealthBudget /> },
    { label: 'Higher education', icon: <ApartmentIcon />, render: () => <HigherEducationBudget /> },
    { label: 'Agriculture', icon: <LocalFloristIcon />, render: () => <AgricultureBudget /> },
    { label: 'Customs revenue', icon: <PolicyIcon />, render: () => <RecentCustomRevenue /> },
];

/** Tabbed view of budget execution and revenue data. */
export default function InfoTab() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    return (
        <div className={classes.root}>
            <StyledTabs
                value={value}
                onChange={(event, next) => setValue(next)}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="Budget and revenue categories"
            >
                {panels.map((panel, index) => (
                    <StyledTab
                        key={panel.label}
                        label={panel.label}
                        icon={panel.icon}
                        {...a11yProps(index)}
                    />
                ))}
            </StyledTabs>

            {panels.map((panel, index) => (
                <TabPanel key={panel.label} value={value} index={index}>
                    <div className={classes.panel}>{panel.render()}</div>
                </TabPanel>
            ))}
        </div>
    );
}
